import { Component } from '@angular/core';
import { ExampleItem } from './nlp-example/nlp-example.component';

@Component({
  selector: 'app-nlp',
  templateUrl: './nlp.component.html',
  styleUrls: ['./nlp.component.scss']
})
export class NlpComponent {
    constructor() {}
    isLoading: boolean = false;
    example_data: ExampleItem | null = {date: null, text: null};
    send_example_data: ExampleItem | null = {date: null, text: null};
    
    updateIsLoadingState(isLoading: boolean) {
      setTimeout(() => {
        this.isLoading = isLoading;
      })
    }

    updateExample(example_data: ExampleItem) {
      this.example_data = {
        date: example_data.date , text: example_data.text
      }
    }

    updateSendExample(example_data: ExampleItem) {
      this.send_example_data = {
        date: example_data.date , text: example_data.text
      }
    }
    
}
